import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { MoveLeft } from "lucide-react";
import { X, ArrowLeft } from "lucide-react";
import truckImg from "../images/truckImg.png";
import Loader from "../components/Common/Loader";
import notValidate from "../images/notvalidate.png";
import wrongImg from "../images/wrongImg.png";
import NoDataImg from "../images/notdata.png";
import { APIEND_POINT, APIUtility } from "../Api";
import cameraLoad from "../images/cameraLoad.gif";
import ImageWithRect from "../components/Common/ImageWithRect";
import RemarkIcon from "../images/svg/RemarkIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { addToast } from "../Redux/CommonSlice/toastSlice";
import { setVehicleNumberMismatch } from "../Redux/CommonSlice/allDataSlice";

const MaingateModal = (props) => {

  const playerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [ImageDetails, setImageDetails] = useState(null);
  const [captureStatus, setCaptureStatus] = useState("capture");
  const [validateData, setValidateData] = useState(null)
  const [capturedImage, setCapturesImages] = useState(null);
  const [RemarkPopupShow, setRemarkPopupShow] = useState(false);
  const [showRemarkOption, setShowRemarkOption] = useState(false)
  const [selectedOption, setSelectedOption] = useState("");
  const [remarkData, setRemarkData] = useState({ remarks: "", sap_vnum_flag: false, ai_vnum_flag: false, corrected_vnum: "" })
  const [errorMessage, setErrorMessage] = useState(null);
  const dispatch = useDispatch();
  const vehicleNumberMismatch = useSelector(state => state.data.vehicleNumberMismatch);

  const iconRef = useRef(null);
  const popupRef = useRef(null);

  const { show, onHide, setSocketOpen, socketOpen, isLiveStreamStart, cameraFrame, qrcodeId, noCameraFound } = props;

  const canvasRef = useRef(null);
  const blob = new Blob([cameraFrame], { type: "image/jpeg" });
  const objectURL = URL.createObjectURL(blob);

  const handleSelection = (event) => {
    const { id } = event.target;
    if (selectedOption === id) {
      setSelectedOption("");
      setRemarkData((prev) => ({
        ...prev,
        sap_vnum_flag: false,
        ai_vnum_flag: false
      }));
    } else {
      setSelectedOption(id);
      if (id === 'sap') {
        setRemarkData((prev) => ({
          ...prev,
          sap_vnum_flag: true,
          ai_vnum_flag: false
        }));
      } else if (id === 'ai') {
        setRemarkData((prev) => ({
          ...prev,
          sap_vnum_flag: false,
          ai_vnum_flag: true
        }));
      } else if (id === 'both') {
        setRemarkData((prev) => ({
          ...prev,
          sap_vnum_flag: true,
          ai_vnum_flag: true
        }));
      }
    }
  };

  useEffect(() => {
    setCaptureStatus("capture");
    if (!show) {
      setErrorMessage(null);
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      fetchValidationMainGate();
    }
  }, [show]);

  const fetchValidationMainGate = async () => {
    setIsLoading(true);
    try {
      const body = { user_vehicle_mapping_id: qrcodeId };

      const res = await APIUtility.getValidationMainGate(body);

      if (res.status == 200) {
        setImageDetails(res.data); // Set state with fetched data
        setErrorMessage(null);
        setIsLoading(false);
      } else if (res.status == 400) {
        setErrorMessage(res.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in fetching QR code details:", error);
      setIsLoading(false);
    }
  };

  const CaptureImage = () => {
    const formData = new FormData();
    setIsLoading(true);
    setCaptureStatus("loading");

    if (cameraFrame) {
      setSocketOpen(false);
      formData.append("file", blob, "captured_image1.jpeg");
      formData.append("file", blob, "captured_image2.jpeg");
      formData.append("file", blob, "captured_image3.jpeg");
      formData.append("file", blob, "captured_image4.jpeg");
      formData.append("file", blob, "captured_image5.jpeg");
      formData.append("user_vehicle_mapping_id", qrcodeId)
      setCapturesImages(objectURL);

      const sendImage = async () => {
        try {
          const res = await APIUtility.ValidateImageSend(formData);
          const data = res?.data;
          setValidateData(data)

          if (res.status === 400) {
            if (data?.sap_vnum && data?.ai_vnum) {
              dispatch(setVehicleNumberMismatch({ sap_vnum: data.sap_vnum, ai_vnum: data.ai_vnum }));
            }
          }

          if (res.status === 200 || res.status === 201) {
            setIsLoading(false);

            if (
              data?.ai_app_extracted_data.license_plate &&
              data?.ai_app_extracted_data.license_plate !== ""
            ) {
              setCaptureStatus("NumberDetected");
              setSocketOpen(false);
            } else {
              setSocketOpen(true);
              setCaptureStatus("recapture");
            }
          } else {

            if (data?.not_validated == 'sap') {
              setCaptureStatus('NotExistInSap')
            } if (data?.not_validated == 'sap_admin') {
              setCaptureStatus('NotExistInSap')
              setShowRemarkOption(true)
            }
            else if (data?.not_validated == 'ai_app') {
              setCaptureStatus('recapture')
            } else {
              setCaptureStatus("recapture");
            }
            setIsLoading(false);
            setSocketOpen(true);
          }
        } catch (error) {
          console.log(error, "error");
          setIsLoading(false);
          setSocketOpen(true);
          setCaptureStatus("somethingWrong");
        }
      };
      sendImage();
    }
  };


  const handleSubmit = async (event) => {

    try {
      const { sap_vnum, ai_vnum } = vehicleNumberMismatch;

      const payload = {
        remarks: remarkData.remarks,
        sap_vnum_flag: remarkData.sap_vnum_flag,
        ai_vnum_flag: remarkData.ai_vnum_flag,
        user_vehicle_mapping_id: qrcodeId,
        sap_vnum,
        ai_vnum
      };

      if (selectedOption === "both" && remarkData.corrected_vnum.trim()) {
        payload.corrected_vnum = remarkData.corrected_vnum;
      }

      const res = await APIUtility.adminRemark(payload);

      if (res.status === 200 || res.status === 201) {
        dispatch(addToast({ message: "Remark Added Successfully", isError: false }));
        setSelectedOption("");
        setRemarkData({ remarks: "", sap_vnum_flag: false, ai_vnum_flag: false, corrected_vnum: "" });
        setRemarkPopupShow(false);
        setShowRemarkOption(false);
      } else {
        dispatch(
          addToast({ message: "Failed While Adding Remark", isError: true })
        );
      }
    } catch (error) {
      console.log(error);
      dispatch(
        addToast({
          message: error.message || "Failed While Adding Remark",
          isError: true
        })
      );
    }
  };

  // Add this function to check if the form is valid
  const isFormValid = () => {
    // Basic validation: must have a selected option and remarks
    if (!selectedOption || !remarkData.remarks.trim()) {
      return false;
    }
    // If "both" is selected, also require corrected vehicle number
    if (selectedOption === "both" && !remarkData.corrected_vnum.trim()) {
      return false;
    }
    return true;
  };

  const togglePopup = () => {
    if (RemarkPopupShow) {
      setSelectedOption("");
      setRemarkData({ remarks: "", sap_vnum_flag: false, ai_vnum_flag: false, corrected_vnum: "" });
    }
    setRemarkPopupShow((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      iconRef.current &&
      !iconRef.current.contains(event.target)
    ) {
      setSelectedOption("");
      setRemarkData({ remarks: "", sap_vnum_flag: false, ai_vnum_flag: false, corrected_vnum: "" });
      setRemarkPopupShow(false);
    }
  };

  useEffect(() => {
    if (RemarkPopupShow) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [RemarkPopupShow]);

  const GenerateQr = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={truckImg} />
      <h2 className={`text-[16px] font-medium text-center mt-4 w-full ${errorMessage ? 'text-[#FF6161]' : ''}`}>
        {errorMessage ? errorMessage : "Capture Vehicle No To Generate QR Code"}
      </h2>
      <button
        onClick={CaptureImage}
        disabled={!isLiveStreamStart || errorMessage}
        className={`text-[16px] lgLp:text-[18px] font-bold text-white text-center bg-[#4DB748] rounded p-[14px] mt-3 ${isLiveStreamStart && !errorMessage ? 'opacity-100' : 'opacity-50'}`}
      >
        Capture Vehicle No.
      </button>
    </div>
  );

  const WaitingLoader = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <div className="">
        <Loader />
      </div>
      <h3 className=" text-[18px] font-bold text-[#4DB748] mt-4">
        Please Wait!
      </h3>
      <p className=" text-[18px] font-medium text-black opacity-[0.70] mt-1 text-center">
        Validating vehicle number details with SAP.
      </p>
    </div>
  );

  const notFound = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={truckImg} />
      <h3 className=" text-[18px] font-semibold text-[#FF6161] mt-3 text-center">
        {
          captureStatus == "recapture" && validateData?.error_title ? validateData?.error_title : ' Vehicle number not found.'
        }

      </h3>
      <p className=" text-[14px] font-medium ">
        {
          captureStatus == "recapture" && validateData?.error_message ? validateData?.error_message : "Please check if you've captured it correctly."
        }

      </p>
      <button
        className=" text-[18px] font-bold text-white text-center bg-[#4DB748] rounded p-[14px] mt-3"
        onClick={CaptureImage}
        isLiveStreamStart={isLiveStreamStart}
      >
        Recapture Vehicle No.
      </button>
    </div>
  );

  const notExistInSap = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={notValidate} />
      <h3 className=" text-[16px] font-semibold text-[#FF6161] mt-3 text-center">
        {
          captureStatus == "NotExistInSap" && validateData?.error_title ? validateData?.error_title : 'Detected Vehicle number not listed in SAP.'
        }
      </h3>
      <p className=" text-[14px] font-normal ">
        {
          captureStatus == "NotExistInSap" && validateData?.error_message ? validateData?.error_message : "Contact Admin for Further Process."
        }
      </p>
      <button onClick={CaptureImage} className=" text-[18px] font-bold text-white text-center bg-[#FF6161] rounded py-[14px] px-[30px] mt-2">
        Revalidate
      </button>
    </div>
  );

  const SomethingWrong = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={wrongImg} />
      <h3 className=" text-[16px] font-semibold text-[#FEC601] mt-3 text-center">
        Something Went Wrong
      </h3>
      <p className=" text-[14px] font-normal text-center">
        We couldn't validate with SAP data. Please validate manually.
      </p>
      <button onClick={CaptureImage} className=" text-[18px] font-bold text-white text-center bg-[#FEC601] rounded py-[14px] px-[30px] mt-2">
        Validate
      </button>
    </div>
  );

  const NoDetails = (
    <div className="flex items-center flex-col justify-center w-full h-full ">
      <img src={NoDataImg} />
      <h3 className=" text-[16px] font-semibold text-[#000] mt-3 text-center">
        Details Not Available
      </h3>
      <p className=" text-[14px] font-normal text-center">
        Details of <span className=" font-semibold">MH 43 BK9188</span> Vehicle
        No. are not available in MParivan{" "}
      </p>
    </div>
  );

  const mParivahanDataFun = (mparivanData) => {
    return [

      { label: "Owner Name", value: mparivanData?.owner_name || "N/A" },
      { label: "Ownership", value: mparivanData?.ownership || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },
      { label: "Financer's Name", value: mparivanData?.financer_name || "N/A" },
      { label: "Registered RTO", value: mparivanData?.registered_rto || "N/A" },
      { label: "Color", value: mparivanData?.color || "N/A" },
      { label: "Unloaded Weight (Kg)", value: mparivanData?.unloaded_weight || "N/A" },
      { label: "RC Status", value: mparivanData?.rc_status || "N/A" },
      { label: "Maker Model", value: mparivanData?.vehicle_maker_model || "N/A" },
      { label: "Vehicle Class", value: mparivanData?.vehicle_class || "N/A" },
      { label: "Fuel Type", value: mparivanData?.vehicle_fuel_type || "N/A" },
      { label: "Fuel Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
      { label: "Engine No.", value: mparivanData?.vehicle_engine_no || "N/A" },
      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },

      { label: "Insurance Expiry", value: mparivanData?.imp_date_insurance_expiry || "N/A" },
      { label: "Vehicle Age", value: mparivanData?.imp_date_vehicle_age || "N/A" },
      { label: "Fitness Upto", value: mparivanData?.imp_date_fitness_upto || "N/A" },
      { label: "Registration Date", value: mparivanData?.vehicle_registration_date || "N/A" },

      { label: "Sleeper Capacity", value: mparivanData?.sleeper_capacity || "N/A" },
      { label: "Standing Capacity", value: mparivanData?.standing_capacity || "N/A" },
      { label: "Emission Norms", value: mparivanData?.vehicle_fuel_norms || "N/A" },
    ]

  }

  return (
    <div>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="!p-0">
          <button
            className=" absolute right-[10px] top-[10px] text-black"
            onClick={() => props.onHide()}
          >
            <X size={26} />
          </button>
          <div className="flex w-full">
            <div className=" w-[68%] bg-[#F9F9F7] py-[20px] px-[20px] rounded-s-xl">
              <div className="flex flex-col h-full">
                <h3 className="flex items-center gap-3 font-bold text-[18px]">
                  <ArrowLeft
                    className=" cursor-pointer"
                    onClick={() => props.onHide()}
                  />{" "}
                  Capture Vehicle No. Plate
                </h3>
                <div className="flex items-center justify-between mt-3">
                  <div className="">
                    <h3 className=" text-[18px] font-normal text-black">
                      UUID : <span className=" font-bold">
                        {ImageDetails?.qr_uuid || '-'}
                      </span>
                    </h3>
                    <p className=" text-[14px] font-medium italic text-black">
                      <span className="mr-2">{ImageDetails?.qr_date_time || "-"}</span>
                      {/* <span>{ImageDetails?.time}</span> */}
                    </p>
                  </div>
                  <div className="">
                    <h3 className=" text-[18px] font-normal text-black">
                      Reporting No. :{" "}
                      <span className=" font-bold">{ImageDetails?.reporting_number || '-'}</span>
                    </h3>
                    <p className=" text-[14px] font-medium italic text-black text-right">
                      {ImageDetails?.reporting_number_date_time || "-"}
                    </p>
                  </div>
                </div>
                <div className="w-full h-[60vh] lgLp:h-[60vh] flex-grow">
                  {!socketOpen ? (
                    <ImageWithRect
                      data={{
                        img: capturedImage,
                        label:
                          captureStatus == "NumberDetected"
                            ? validateData?.ai_app_extracted_data.license_plate
                            : "-",
                        ...validateData?.ai_app_extracted_data,
                      }}
                    />
                  ) : (

                    noCameraFound ? <div className="w-full h-full bg-white flex items-center justify-center">

                      <img
                        className="w-auto h-auto object-fill rounded-lg"
                        id="liveViewId"
                        ref={playerRef}
                        src={'https://t3.ftcdn.net/jpg/05/15/33/64/360_F_515336412_OgofSpIb0z5iw8GLSh1PI5mNHNOmrcEG.jpg'}
                      />
                    </div> : isLiveStreamStart ? <img
                      className="w-full h-full object-fill rounded-lg"
                      id="liveViewId"
                      ref={playerRef}
                      src={objectURL}
                    /> : <div className="w-full h-full flex items-center justify-center">

                      <img
                        className="w-auto h-auto object-fill rounded-lg"
                        id="liveViewId"
                        ref={playerRef}
                        src={cameraLoad}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[32%] py-[20px] px-[20px]">
              <div className="">
                <label className=" text-[13px] font-medium mb-1">
                  Detected Vehicle No.
                </label>
                <div className="bg-[#FBFBFB] h-[45px] relative  rounded-[4px] border-2 border-gray-400 flex items-center justify-between px-2">
                  <h2 className=" text-[16px] font-semibold text-black m-0 ">
                    {captureStatus == "NumberDetected" ? validateData?.ai_app_extracted_data.license_plate : '--'}
                  </h2>
                  {
                    captureStatus == "NumberDetected" && <div className=" bg-[#3da91c2f]  text-[#3DA91C] font-bold text-[12px] p-2 rounded flex items-center justify-center">
                      {validateData?.ai_app_extracted_data?.confidence_score}%
                    </div>
                  }

                  {
                    showRemarkOption && <div
                      ref={iconRef}
                      className="w-[35px] h-[35px] p-[3px] bg-remarkicon rounded flex items-center justify-center cursor-pointer"
                      onClick={togglePopup}
                    >
                      <img src={RemarkIcon} alt="Remark Icon" />
                    </div>
                  }

                  {RemarkPopupShow && (
                    <div
                      ref={popupRef}
                      className="absolute top-full mt-2 -right-16 bg-white shadow-md p-4 rounded-lg z-50 w-[346px] h-[478px]"
                    >
                      <form className="space-y-3" onSubmit={handleSubmit}>
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="sap"
                            className="custom-checkbox mr-2 cursor-pointer"
                            checked={selectedOption === "sap"}
                            onChange={handleSelection}
                          />
                          <label htmlFor="sap" className="flex items-center cursor-pointer">
                            <span className="text-black text-[17px] font-medium font-['Roboto']">
                              Correction Require in{" "}
                            </span>
                            <span className="text-red-500 text-[17px] font-medium font-['Roboto'] ml-1">
                              SAP
                            </span>
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="ai"
                            className="custom-checkbox mr-2 cursor-pointer"
                            checked={selectedOption === "ai"}
                            onChange={handleSelection}
                          />
                          <label htmlFor="ai" className="flex items-center cursor-pointer">
                            <span className="text-black text-[17px] font-medium font-['Roboto']">
                              Correction Require in{" "}
                            </span>
                            <span className="text-red-500 text-[17px] font-medium font-['Roboto'] ml-1">
                              AI Application
                            </span>
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="both"
                            className="custom-checkbox mr-2 cursor-pointer"
                            checked={selectedOption === "both"}
                            onChange={handleSelection}
                          />
                          <label htmlFor="both" className="flex items-center cursor-pointer">
                            <span className="text-black text-[17px] font-medium font-['Roboto']">
                              Correction Require in{" "}
                            </span>
                            <span className="text-red-500 text-[17px] font-medium font-['Roboto'] ml-1">
                              Both
                            </span>
                          </label>
                        </div>

                        {selectedOption === "both" && (
                          <div>
                            <label htmlFor="correctedVnum" className="block font-bold mb-2">
                              Corrected Vehicle Number
                            </label>
                            <input
                              type="text"
                              id="correctedVnum"
                              value={remarkData.corrected_vnum}
                              onChange={(e) => setRemarkData((prev) => ({ ...prev, corrected_vnum: e.target.value }))}
                              className="w-full border border-gray-300 p-2 rounded-md h-[45px]"
                              placeholder="Enter Corrected Vehicle Number"
                            />
                          </div>
                        )}

                        <div>
                          <label
                            htmlFor="remark"
                            className="block font-bold mb-2"
                          >
                            Remark
                          </label>
                          <textarea
                            id="remark"
                            value={remarkData.remarks}
                            onChange={(e) => setRemarkData((prev) => ({ ...prev, remarks: e.target.value }))}
                            className={`w-full border border-gray-300 p-2 rounded-md resize-none ${selectedOption === "both" ? 'h-[141px]' : 'h-[230px]'}`}
                            rows="3"
                            placeholder="Enter Your Remarks Here"
                          />
                        </div>
                        <button
                          type="submit"
                          className={`w-full py-2 rounded-md font-bold ${isFormValid() ? 'bg-customGreen text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                          disabled={!isFormValid()}
                        >
                          Save
                        </button>
                      </form>

                      <style jsx>{`
                        .custom-checkbox {
                          width: 17px;
                          height: 17px;
                          border: 1px solid #000000;
                          margin-top: 0;
                          vertical-align: middle;
                        }
                        .custom-checkbox:checked {
                          background-color: #000000;
                          border-color: #000000;
                        }
                      `}</style>
                    </div>
                  )}
                  {/* <div className=" bg-[#3da91c2f]  text-[#3DA91C] font-bold text-[12px] w-[35px] h-[35px] rounded flex items-center justify-center">
                    94%
                  </div> */}
                </div>
              </div>
              <div className="border-b mt-3">
                <h4 className=" text-[14px] font-medium">Vehcile Details</h4>
                {
                  captureStatus == "NumberDetected" ? <p className="text-[#3DA91C]  text-[13px] font-medium m-0 mb-1" >
                    {validateData?.last_updated}
                  </p> : <h3 className=" text-gray-400 text-[13px] font-medium m-0 mb-1">
                    Data Not Available Yet
                  </h3>
                }
                {/* <p className='text-[13px] font-normal text-black opacity-[0.3] m-0 mb-1'>Data Not Available Yet</p>
                 */}

              </div>
              <div className="h-screen_h_300 overflow-y-auto hideScrollBar flex w-full">
                {captureStatus == "capture"
                  ? GenerateQr
                  : captureStatus == "loading"
                    ? WaitingLoader
                    : captureStatus == "recapture"
                      ? notFound
                      : captureStatus == "NumberDetected" && validateData?.m_parivahan_data && Object.keys(validateData?.m_parivahan_data).length > 0
                        ? <div className="h-full w-full flex flex-col gap-1 bg-[#FAFAFA]">
                          {mParivahanDataFun(validateData?.m_parivahan_data).map((each, i) => {
                            return (

                              <div
                                key={i}
                                className="flex items-center   w-full"
                              >
                                <div className="flex items-center pl-2 w-1/2 py-2">
                                  <p className="m-0 font-normal text-[14px] text-[#000] h-full">
                                    {each.label} :
                                  </p>
                                </div>
                                <div className="flex items-center pl-2 w-1/2 bg-[#F5F5F5] h-full py-2">
                                  <p className="m-0 font-medium text-[14px] text-[#000]">
                                    {each.value}
                                  </p>
                                </div>
                              </div>

                            );
                          })}
                        </div>
                        : captureStatus == "NotExistInSap"
                          ? notExistInSap : captureStatus == "somethingWrong" ? SomethingWrong
                            : NoDetails}

              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MaingateModal;
